module.exports = __webpack_public_path__ + "static/assets/ed10a97c993e349f78b832bc971eb621.svg";